export default __webpack_public_path__ + "static/media/yellowArrowDown.6786bce2.svg";